import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import DashboardLayout from "@/pages/DashboardLayout";
import Overview from "@/pages/Overview";
import Renewals from "@/pages/Renewals";
import PastDue from "@/pages/PastDue";
import EmailTriage from "@/pages/EmailTriage";
import MarketTrends from "@/pages/MarketTrends";
import Assistant from "@/pages/Assistant";
import { Toaster } from "@/components/ui/sonner";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-stone-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/app"
            element={
              <Protected>
                <DashboardLayout />
              </Protected>
            }
          >
            <Route index element={<Overview />} />
            <Route path="renewals" element={<Renewals />} />
            <Route path="past-due" element={<PastDue />} />
            <Route path="triage" element={<EmailTriage />} />
            <Route path="market" element={<MarketTrends />} />
            <Route path="assistant" element={<Assistant />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
